import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-text.css';
import { EGDSParagraphSizes } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSParagraph = props => {
  const {
    size,
    children,
    className,
    typeStyle,
    ...attributes
  } = props;
  const {
    data: contextData,
    context
  } = useEGDSContext();
  const {
    bottomScrimContext,
    overlayScrimContext,
    contextClassNames
  } = contextData ?? {};
  const baseClassName = 'uitk-paragraph';
  const wrapperClassNames = getClassNameList(baseClassName, !bottomScrimContext && size && EGDSParagraphSizes.get(size), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, context === 'uitk-dialog-context' && 'in-dialog', contextClassNames?.EGDSParagraph, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
  return children ? jsx("p", {
    className: wrapperClassNames,
    ...(typeStyle && {
      'type-style-theme': typeStyle.customTheme || 'standard'
    }),
    ...attributes,
    children: children
  }) : null;
};
EGDSParagraph.displayName = 'EGDSParagraph';
EGDSParagraph.defaultProps = {
  size: 2
};
export { EGDSParagraph };